import React from 'react';
import { FunctionTypes } from '../../../components/ContributorSection/helpers';
import { PubMainTypeEnum } from '../../../types';
export var DEFAULT_SELECTED_SEARCH_TYPE_INDEX = 2;
export var TabHeaders;
(function (TabHeaders) {
  TabHeaders["IN_PRINT"] = "In-Print";
  TabHeaders["ONLINE"] = "Online";
  TabHeaders["ONLINE_DATABASE"] = "Online database";
})(TabHeaders || (TabHeaders = {}));
export var ReviewIntroductionOptions;
(function (ReviewIntroductionOptions) {
  ReviewIntroductionOptions["SectionReviewer"] = "Reviewer";
  ReviewIntroductionOptions["SectionSourceAuthor"] = "Source author";
})(ReviewIntroductionOptions || (ReviewIntroductionOptions = {}));
export var SourceFromOptions = [{
  key: PubMainTypeEnum.PUB_MAGAZINE,
  value: 'Magazine'
}, {
  key: PubMainTypeEnum.PUB_NEWSPAPER,
  value: 'Newspaper'
}, {
  key: PubMainTypeEnum.PUB_JOURNAL,
  value: 'Journal'
}];

/** generic section name and title */
export var INPRINT_PUB_INFO_SECTION_NAME = 'pubnonperiodical';
export var INPRINT_PUB_INFO_SECTION_TITLE = 'In print publication info';
export var JOURNAL_PUB_INFO_SECTION_NAME = 'pubjournal';
export var JOURNAL_PUB_INFO_SECTION_TITLE = 'Journal publication info';
export var WEBSITE_PUB_INFO_SECTION_NAME = 'pubonline';
export var WEBSITE_PUB_INFO_SECTION_TITLE = 'Website publication info';
export var ONLINE_DATABASE_PUB_INFO_SECTION_NAME = 'pubdatabase';
export var ONLINE_DATABASE_PUB_INFO_SECTION_TITLE = 'Online database publication info';
export var REVIEW_TITLE_INPUT_TEST_ID = 'review-title-input-test-id';
export var REVIEW_MEDIUM_INPUT_TEST_ID = 'review-medium-input-test-id';
export var SOURCE_REVIEWED_INPUT_TEST_ID = 'source-review-input-test-id';
export var PREFIX_FOR_TEST_IDS = 'review-form';
export var DOI_HELPER_TEXT = 'If your source was found online, the online publication information will be replaced by the DOI.';
export var TestIds = {
  REVIEW_PUB_ABSTRACT_SECTION: "".concat(PREFIX_FOR_TEST_IDS, "-pub-abstract-sec-test-id"),
  REVIEW_PUB_INFO_SECTION: "".concat(PREFIX_FOR_TEST_IDS, "-pub-info-sec-test-id"),
  REVIEW_ONLINE_DB_PUB_INFO_SECTION: "".concat(PREFIX_FOR_TEST_IDS, "-online-db-pub-info-sec-test-id"),
  REVIEW_WEBSITE_PUB_INFO_SECTION: "".concat(PREFIX_FOR_TEST_IDS, "-website-pub-info-sec-test-id")
};
export var ReviewerRoleOptions = [{
  uuid: FunctionTypes.REVIEWER,
  value: FunctionTypes.REVIEWER,
  child: /*#__PURE__*/React.createElement(React.Fragment, null, ReviewIntroductionOptions.SectionReviewer)
}, {
  uuid: FunctionTypes.REVIEWED,
  value: FunctionTypes.REVIEWED,
  child: /*#__PURE__*/React.createElement(React.Fragment, null, ReviewIntroductionOptions.SectionSourceAuthor)
}];